import React from 'react';
import Instructor from './Instructor';
import Rating from './Rating';
import Hagar from './Hagar';

const Member = (props) => {
    const {member, selectResource} = props;

    return (
        <li className="list-item" key={member.member_number}>
        <button
        className="list-item-member"
        href={`${member.member_number}`}
        onClick={(e) => selectResource(e, member)}
        >
        <div className="list-item-member-details">
            <div className="col">
            <p className="list-item-member-number">{member.member_number}</p>
            <p className="list-item-member-name">
                {member.full_name}
            </p>
            <address>{member.address}</address>
            <div className="list-item-member-instructor">
                <Instructor wing_type='pg' member={member} />
                <Instructor wing_type='hg' member={member} />
            </div>
            </div>
            <div className="col">
            <p className="list-item-member-expiry-date">{member.expiry_dates.membership}</p>
            <div className="list-item-member-ratings">
                <Rating wing_type='pg' member={member} />
                <Rating wing_type='hg' member={member} />
            </div>
            {member.hagar && <Hagar />}
            </div>
        </div>
        </button>
    </li>
  );
}

export default Member;